import React from "react";
import "./RollAccessKeyImage.css"

export default function RollAccessKeyImage(): JSX.Element{
    return (
        <img className="roll-access-key-image" src="./images/RollAccessKey.png" alt=""></img>
    )
}